module.exports = __webpack_public_path__ + "img/callexperiences.ad4ea102.jpg";